export default __webpack_public_path__ + "static/media/MoneyBarn_LOA.c8c0697c.pdf";